import { BaseIcon, BaseIconProps } from "@/shared/icons/BaseIcon";

export function PayPassIcon({ ...props }: BaseIconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 20 24">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M2 8.32A6.4 6.4 0 0 1 3.2 12 6.4 6.4 0 0 1 2 15.68m4.25-9.47A10.12 10.12 0 0 1 8.12 12c0 2.03-.64 4.02-1.87 5.79M10.49 4.1a13.7 13.7 0 0 1 2.58 7.9c0 2.77-.88 5.5-2.57 7.9M14.74 2A17.36 17.36 0 0 1 18 12c0 3.5-1.12 6.95-3.26 10"
      />
    </BaseIcon>
  );
}
